



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// approvePlan
// APPROVEPLAN


const APPROVEPLAN= createAsyncThunk(
  "approvePlan/approvePlan",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const approvePlanSlice = createSlice({
  name: "approvePlanSlice",
  initialState: {
    approvePlan: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfapprovePlan: (state) => {
        state.approvePlan.loading = false
        state.approvePlan.error = false
        state.approvePlan.data = []
        state.approvePlan.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(APPROVEPLAN.fulfilled, (state, action) => {
      state.approvePlan = {
        ...state.approvePlan,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEPLAN.pending, (state, action) => {
      state.approvePlan = {
        ...state.approvePlan,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEPLAN.rejected, (state, action) => {
      state.approvePlan = {
        ...state.approvePlan,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const approvePlanAction = {
    APPROVEPLAN,
};

export { approvePlanAction };
export default approvePlanSlice.reducer;
export const {setInitialStateOfapprovePlan} = approvePlanSlice.actions
